import AxiosConfig from "axiosConfig";
import * as CONSTANT from "constants/text";

/*
 * Method for deleting a group invitation
 * Calls the delete endpoint to either delete a Group Membership Invitation
 */
export const deleteInvite = function (groupRequestId, redirectObject) {
  /*Call endpoint*/
  AxiosConfig.delete(`groups/invitations/${groupRequestId}/`);
  /*route back to a specified page*/
  if (redirectObject) {
    // redirect back to the group profile
    setTimeout(() =>
      redirectObject.history.push(
        {
          pathname:
            "/groups/" +
            CONSTANT.VIEW +
            "/" +
            redirectObject.group_id +
            "/" +
            redirectObject.group_name,
        },
        100
      )
    );
  } else {
    // redirect back to the groups page.
    setTimeout(() => window.location.assign("/groups"), 100);
  }
};

/*
 * Method for accepting a group invitation
 * Calls the accept endpoint to POST a new Group Membership
 */
export const acceptInvite = function (username, groupId, redirectObject) {
  /*form data*/
  let form = new FormData();
  /*add in the groupId and username to the request*/
  form.append("user", username);
  form.append("group", groupId);

  /*Call endpoint*/
  AxiosConfig.post(`groups/membership/`, form);
  /*route back to a specified page*/
  if (redirectObject) {
    // redirect back to the group profile
    setTimeout(() =>
      redirectObject.history.push(
        {
          pathname:
            "/groups/" +
            CONSTANT.VIEW +
            "/" +
            redirectObject.group_id +
            "/" +
            redirectObject.group_name,
        },
        100
      )
    );
  } else {
    // redirect back to the groups page.
    setTimeout(() => window.location.assign("/groups"), 100);
  }
};

/*
 * Method for joining a public group
 * Calls the join endpoint to POST a new Group Membership
 */
export const join = function (groupId) {
  /*form data*/
  let form = new FormData();
  /*add in the groupId and username to the request*/
  form.append("group", groupId);

  /*Call endpoint*/
  AxiosConfig.post(`groups/join/`, form);
  setTimeout(() => window.location.assign("/groups"), 70);
};

/*
 * Method for posting a group invitation
 * Calls the delete endpoint to either delete a Group Membership Invitation
 */
export const invite = function (username, groupId) {
  /*form data*/
  let form = new FormData();
  /*add in the groupId and username to the request*/
  form.append("user", username);
  form.append("group", groupId);

  /*Call endpoint*/
  AxiosConfig.post(`groups/invitations/`, form);
};

/*
 * Method for changing a group member's role
 * Calls the PATCH endpoint
 */
export const changeRole = function (groupId, username, role) {
  let form_data = new FormData();
  // add the newrole to the payload
  form_data.append("role", role);

  /*Call endpoint*/
  AxiosConfig.patch(
    `groups/${groupId}/members/${username}/`,
    form_data
  ).then((response) => window.location.reload());
};

/*
 * Method for posting a group request
 * Calls the POST endpoint to make a new GroupMembershipInvite of type "Request"
 */
export const request = function (groupId) {
  /*form data*/
  let form = new FormData();
  /*add in the groupId and username to the request*/
  form.append("group", groupId);

  /*Call endpoint*/
  AxiosConfig.post(`groups/requests/`, form);
};

/*
 * Method for deleting a group membership
 * call endpoint groups/<group_id>/members/<username>
 */
export const deleteMembership = function (
  groupId,
  username,
  type,
  onlyOwnerNotification
) {
  /*Call endpoint*/
  AxiosConfig.delete(`groups/${groupId}/members/${username}/`)
    .then((response) => {
      // if(response.data.)

      if (type === CONSTANT.LEAVE) {
        // user has left the group so return to groups page.
        setTimeout(() => window.location.assign("/groups"), 100);
      } else if (type === CONSTANT.REMOVE_FROM_GROUP) {
        // user has left the group so return to groups page.
        setTimeout(() => window.location.reload(), 100);
      }
    })
    .catch(function (error) {
      onlyOwnerNotification();
    });
};

/**
 * 
  Decline child's invite or request to join a group
 */

export const declineGaurdian = function (invite_id) {
  AxiosConfig.delete(`/groups/invitations/${invite_id}/`).then((response) => {
    window.location.assign("/manage-child-tribe");
  })
  .catch();
};

/**
 * 
  Accept child's invite or request to join a group
 */

export const acceptGaurdian = function (invite_id) {  
  AxiosConfig.patch(`/groups/approve-invite/${invite_id}/`).then((response) => {
    window.location.assign("/manage-child-tribe");
  })
  .catch();
};
